import { Component, Input, OnInit, inject, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RegisterComponent } from '../../components/component-lookup';
import { FlexComponent } from '../flex-component/flex.component';
import { SessionService } from '../../../shared/services/session.service';
import { StateService } from '../../services/state.service';

@RegisterComponent('FlexHeader')
@Component({
  selector: 'app-flex-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './flex-header.component.html',
  styleUrl: './flex-header.component.scss'
})
export class FlexHeaderComponent extends FlexComponent implements OnInit {
  title = input<string>('');
  expandable = input<boolean>(false);
  expanded = input<boolean>(false);

  @Input() isRowExpanded = signal<boolean>(false);
  expandEvent = output<boolean>();

  private sessionService = inject(SessionService);
  private stateService = inject(StateService);
  readonly isPrinting = this.stateService.isPrinting;

  override ngOnInit(): void {
    super.ngOnInit();
    const key = `row-${this.title()}`;
    const expanded = this.sessionService.get(key) as boolean ?? this.stateService.getPrintSessionData(key) as boolean ?? this.expanded();
    if (expanded) {
      this.expandEvent.emit(expanded);
    }
  }

  onClick(): void {
    const expanded = !this.isRowExpanded();
    this.expandEvent.emit(expanded);
    const key = `row-${this.title()}`;
    this.sessionService.set(key, expanded, false);
    this.stateService.setPrintSessionData(key, expanded);
  }
}
